import React from "react";
import {
  Award,
  CircleDollarSign,
  Star,
  Swords,
  TriangleAlert,
  type LucideIcon,
} from "lucide-react";
import { cn } from "@/lib/utils";

/** Big-5 categories (Marcus Sheridan "They Ask, You Answer"), keyed to match the
 *  backend question `category` values. */
export type Big5Category =
  | "cost"
  | "problems"
  | "head_to_head"
  | "reviews"
  | "best_of";

export const BIG5_LABELS: Record<Big5Category, string> = {
  cost: "Cost",
  problems: "Problems",
  head_to_head: "Head-to-Head",
  reviews: "Reviews",
  best_of: "Best Of",
};

/** One icon per Big-5 category. Single source of truth so the buyer-creation
 *  wizard and the verdict (and anywhere else) show the SAME mark per category.
 *  Consumers render at their own size: `const Icon = BIG5_ICONS[cat]; <Icon size={16} />`. */
export const BIG5_ICONS: Record<Big5Category, LucideIcon> = {
  cost: CircleDollarSign,
  problems: TriangleAlert,
  head_to_head: Swords,
  reviews: Star,
  best_of: Award,
};

type Props = {
  category: Big5Category;
  /** Optional count badge (e.g. "2/2"), shown as the prototype's `.chip .ct`. */
  count?: string;
  active?: boolean;
  className?: string;
};

/** Big-5 category chip, ported from the prototype's `.chip`. */
export function Big5Chip({ category, count, active, className }: Props) {
  return (
    <span className={cn("vb-chip", active && "vb-chip--active", className)}>
      {BIG5_LABELS[category]}
      {count != null && <span className="vb-chip__ct tnum">{count}</span>}
    </span>
  );
}

export default Big5Chip;
